export const solutionsDetailedData = [
  {
    id: 1,
    title: 'Endpoint Protection',
    slug: 'endpoint-protection',
    icon: 'Shield',
    shortDescription: 'Comprehensive EPP/EDR solutions to protect every device in your organization.',
    fullDescription: 'Safeguard your entire organization with our advanced Endpoint Protection Platform (EPP) and Endpoint Detection and Response (EDR) solutions. We deploy industry-leading security software that protects desktops, laptops, mobile devices, and servers from malware, ransomware, and advanced persistent threats. Our solutions include real-time monitoring, automated threat response, and comprehensive reporting to keep your business secure 24/7.',
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800',
    features: [
      'Real-time Threat Detection',
      'Automated Response & Remediation',
      'Ransomware Protection',
      'Zero-day Attack Prevention',
      'Centralized Management Console',
      'Compliance Reporting'
    ],
    benefits: [
      'Protect all endpoints from cyber threats',
      'Reduce security incident response time',
      'Meet compliance requirements',
      'Minimize business disruption from attacks'
    ]
  },
  {
    id: 2,
    title: 'Mobile Device Management',
    slug: 'mobile-device-management',
    icon: 'Smartphone',
    shortDescription: 'Centrally manage and secure all mobile devices across your enterprise.',
    fullDescription: 'Take complete control of your mobile ecosystem with our comprehensive Mobile Device Management (MDM) solutions. Whether you have company-owned devices or a BYOD policy, we help you manage, secure, and monitor all smartphones and tablets across your organization. Our MDM platform enables you to enforce security policies, deploy apps, manage updates, and remotely wipe devices if lost or stolen, all from a single console.',
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800',
    features: [
      'Device Enrollment & Configuration',
      'App Management & Distribution',
      'Security Policy Enforcement',
      'Remote Lock & Wipe',
      'Location Tracking',
      'BYOD Support'
    ],
    benefits: [
      'Secure corporate data on mobile devices',
      'Streamline device provisioning',
      'Reduce IT support overhead',
      'Enable safe BYOD practices'
    ]
  },
  {
    id: 3,
    title: 'Backup Solutions',
    slug: 'backup-solutions',
    icon: 'Database',
    shortDescription: 'Automated, tested, and reliable backup strategies to protect critical data.',
    fullDescription: 'Never lose critical business data with our enterprise-grade backup solutions. We implement automated backup systems that protect your files, databases, applications, and entire systems. Our solutions include regular backup testing, multiple retention policies, and fast recovery options to ensure your business can quickly bounce back from any data loss scenario. Whether on-premises, cloud, or hybrid, we design backup strategies that fit your needs.',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800',
    features: [
      'Automated Scheduled Backups',
      'Incremental & Full Backups',
      'Cloud & On-premises Options',
      'Instant File Recovery',
      'Disaster Recovery Planning',
      'Backup Verification Testing'
    ],
    benefits: [
      'Protect against data loss',
      'Quick recovery from disasters',
      'Meet compliance requirements',
      'Peace of mind with tested backups'
    ]
  },
  {
    id: 4,
    title: 'Data Loss Prevention (DLP)',
    slug: 'data-loss-prevention',
    icon: 'Lock',
    shortDescription: 'Prevent unauthorized data exfiltration and ensure regulatory compliance.',
    fullDescription: 'Protect your sensitive information with our Data Loss Prevention solutions. We implement policies and technologies that monitor, detect, and block unauthorized data transfers across your network, endpoints, and cloud applications. Our DLP solutions help you maintain compliance with regulations like GDPR, HIPAA, and PCI-DSS by preventing accidental or malicious data leaks through email, USB drives, cloud storage, and other channels.',
    image: 'https://images.unsplash.com/photo-1639322537228-f710d846310a?w=800',
    features: [
      'Content Inspection & Classification',
      'Policy-based Data Controls',
      'Email & Web Filtering',
      'USB & Device Control',
      'Cloud App Security',
      'Incident Reporting & Alerts'
    ],
    benefits: [
      'Prevent data breaches',
      'Ensure regulatory compliance',
      'Protect intellectual property',
      'Monitor data movement'
    ]
  },
  {
    id: 5,
    title: 'Data Centre & Cloud',
    slug: 'data-centre-cloud',
    icon: 'Cloud',
    shortDescription: 'Hybrid and multi-cloud solutions tailored to your performance and budget goals.',
    fullDescription: 'Transform your IT infrastructure with our comprehensive data centre and cloud solutions. We design, build, and manage hybrid cloud environments that combine the best of on-premises infrastructure and public cloud services. Whether you need to migrate to AWS, Azure, Google Cloud, or build a private cloud, our experts ensure seamless integration, optimal performance, and cost efficiency for your business applications.',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800',
    features: [
      'Cloud Migration Services',
      'Hybrid Cloud Architecture',
      'Multi-cloud Management',
      'Infrastructure as Code',
      'Cost Optimization',
      '24/7 Monitoring & Support'
    ],
    benefits: [
      'Scalable infrastructure',
      'Reduced capital expenses',
      'High availability and disaster recovery',
      'Flexible and agile operations'
    ]
  },
  {
    id: 6,
    title: 'CRM Solutions',
    slug: 'crm-solutions',
    icon: 'Users',
    shortDescription: 'Customer relationship management platforms to streamline sales and support.',
    fullDescription: 'Enhance customer relationships and boost sales with our CRM solutions. We implement and customize leading CRM platforms like Salesforce, Zoho CRM, and Microsoft Dynamics to help you manage customer interactions, track sales pipelines, automate marketing campaigns, and provide exceptional customer service. Our CRM solutions integrate with your existing tools and provide actionable insights to grow your business.',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800',
    features: [
      'Contact & Lead Management',
      'Sales Pipeline Tracking',
      'Marketing Automation',
      'Customer Support Ticketing',
      'Analytics & Reporting',
      'Mobile CRM Access'
    ],
    benefits: [
      'Improve customer satisfaction',
      'Increase sales conversion rates',
      'Better team collaboration',
      'Data-driven decision making'
    ]
  },
  {
    id: 7,
    title: 'Network & Storage Solutions',
    slug: 'network-storage-solutions',
    icon: 'HardDrive',
    shortDescription: 'High-performance network infrastructure and scalable storage architectures.',
    fullDescription: 'Build a robust and scalable IT foundation with our network and storage solutions. We design and implement enterprise-grade network infrastructure including switches, routers, firewalls, and wireless systems. Our storage solutions encompass NAS, SAN, and object storage to handle your growing data needs. From planning to deployment and ongoing management, we ensure your network and storage systems deliver optimal performance, security, and reliability.',
    image: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=800',
    features: [
      'Enterprise Network Design',
      'SAN & NAS Implementation',
      'Network Security Integration',
      'High-speed Connectivity',
      'Storage Virtualization',
      'Performance Optimization'
    ],
    benefits: [
      'Fast and reliable connectivity',
      'Scalable storage capacity',
      'Reduced data access latency',
      'Enhanced data protection'
    ]
  },
  {
    id: 8,
    title: 'Biometric & Attendance',
    slug: 'biometric-attendance',
    icon: 'Fingerprint',
    shortDescription: 'Advanced biometric systems for precise workforce attendance management.',
    fullDescription: 'Modernize your attendance tracking with our biometric and attendance management solutions. We deploy fingerprint scanners, facial recognition systems, and RFID-based attendance devices that eliminate buddy punching and ensure accurate time tracking. Our solutions integrate with payroll systems and provide real-time attendance reports, shift management, and leave tracking through easy-to-use web and mobile interfaces.',
    image: 'https://images.unsplash.com/photo-1633265486064-086b219458ec?w=800',
    features: [
      'Fingerprint & Face Recognition',
      'Real-time Attendance Tracking',
      'Shift Management',
      'Leave Management System',
      'Payroll Integration',
      'Mobile & Web Access'
    ],
    benefits: [
      'Eliminate time theft',
      'Accurate attendance records',
      'Streamlined payroll processing',
      'Improved workforce management'
    ]
  }
];